export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff?ee26f57bc9e3619b022b2c0ea0fc4660";